// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import iView from "iview";
import i18n from "@/locale";
import config from "@/config";
import importDirective from "@/directive";
import { directive as clickOutside } from "v-click-outside-x";
import installPlugin from "@/plugin";
import "./index.less";
import "@/assets/icons/iconfont.css";
import Icon from "@/components/icon/index.js";
import axios from "@/libs/api.request";
import filter from "@/filter/";
import NoData from "_c/no-data/index.vue";
import VueClipboard from "vue-clipboard2";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import {getDicts} from "@/api/dict"
import { TOKEN_KEY } from '@/libs/util';
import baseURL from '@/config/url';
import {formatTime} from "@/libs/index"
import { Message } from 'iview'


import sensors from 'sa-sdk-javascript';

sensors.init({
  server_url: `https://shangbanzu.datasink.sensorsdata.cn/sa?project=jybfy&token=fe97a12f8f9cd5db`,
  is_track_single_page: true,
  use_client_time: true,
  send_type: 'beacon',
  show_log: false
});
// 注册公共属性
sensors.registerPage({
  plarfrom_name: 'web'
});
sensors.quick('autoTrack'); // 用于采集 $pageview 事件。

VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

// 实际打包时应该不引入mock
/* eslint-disable */
// if (process.env.NODE_ENV !== 'production') require('@/mock')
(iView as any).Modal.props.maskClosable.default = false;
Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
});

Vue.use(Icon);
Vue.use(filter);
Vue.prototype.getDicts = getDicts;

/**
 * @description 注册admin内置插件
 */
installPlugin(Vue);
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false;
/**
 * @description 全局注册应用配置
 */

Vue.prototype.$axios = axios;
/**
 * @description 全局注册axios
 */
Vue.prototype.$config = config;

Vue.prototype.formatTime = formatTime
/**
 * 注册指令
 */
// window.store = store;
Vue.prototype.$store = store;
Vue.prototype.$eventBus = new Vue();
declare global {
  interface Window {
    router?: any; // 引入'vue-router'库的Router类型
  }
}
window.router = router;

Vue.prototype.$uploader = {
  headers() {
    return { Authorization: 'Bearer ' + sessionStorage.getItem(TOKEN_KEY) };
  },
  beforeUpload(file) {
    const isRightSize = file.size / 1024 / 1024 < 2;
    if (!isRightSize) {
      (Message as any).error('文件大小超过 2MB');
    }
    return isRightSize;
  },
  action: baseURL + 'front/v1/common/uploadFile'
};
/**
 * 注册组件
 */
Vue.component("no-data", NoData);

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
});

importDirective(Vue);
Vue.directive("clickOutside", clickOutside);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  render: h => h(App)
});
